// extracted by mini-css-extract-plugin
module.exports = {"container":"ResetPassword_container__2S2BV","formContainer":"ResetPassword_formContainer__3QVAy","logo":"ResetPassword_logo__3dcdT","buttom":"ResetPassword_buttom__P45ot"};